export class PositionTeam {
  description: string = '';
  name: string = '';
  state: number = 0;
  id: string = '00000000-0000-0000-0000-000000000000';
  timeString: Date = new Date();
  positions: string[] = [];
}
